export interface IFacility {
  id?: string;
  code: string;
  name: string;
  displayName?: string;
  facilityTypeEnum: number;
  businessUnitId: string;
  businessUnitName?: string;
  addressId?: string;
  phoneNumber?: string;
  hotline?: string;
  displayAddress?: string;
  isActive?: boolean;
  tenantId?: string;
}

export enum FacilityType {
  Warehouse = 1,
  Store = 2,
  Office = 3,
  Plant = 4,
}

export const FacilityTypeList = [
  { value: FacilityType.Warehouse, label: 'Facility.Type.Warehouse' },
  { value: FacilityType.Store, label: 'Facility.Type.Store' },
  { value: FacilityType.Office, label: 'Facility.Type.Office' },
  { value: FacilityType.Plant, label: 'Facility.Type.Plant' },
];
